
import Icon        from 'app/components/common/icon';
import fileHelpers from 'app/helpers/files';
import utils       from 'app/helpers/utils';

const FieldTypes = {
  TEXT_SHORT: 'text-short',
  TEXT_LONG: 'text-long',
  SELECT: 'select',
  MULTI_SELECT: 'multi-select',
  NONPROFIT: 'nonprofit',
  FILE: 'file',
  DATE: 'date',
  MONETARY_AMOUNT: 'monetary-amount',
  ADDRESS: 'address',
  PHONE: 'phone',
  NUMBER: 'number',
};

const typeObjMap = {
  [FieldTypes.TEXT_SHORT]: {
    label: 'Short Answer',
    defaultOpts: {},
    icon: Icon.TextStyle,
  },
  [FieldTypes.TEXT_LONG]: {
    label: 'Long Answer',
    defaultOpts: {},
    icon: Icon.CatPublicPolicy,
  },
  [FieldTypes.DATE]: {
    label: 'Date',
    defaultOpts: {},
    icon: Icon.CalendarDate,
  },
  [FieldTypes.NUMBER]: {
    label: 'Number',
    defaultOpts: {min: 0},
    icon: Icon.Hash,
  },
  [FieldTypes.MONETARY_AMOUNT]: {
    label: 'Dollar Amount',
    defaultOpts: {min: 0},
    icon: Icon.CurrencyDollar,
  },
  [FieldTypes.FILE]: {
    label: 'File Upload',
    defaultOpts: {types: [fileHelpers.CommonTypes.PDF, fileHelpers.CommonTypes.WORD, fileHelpers.CommonTypes.IMAGE], isMulti: false},
    icon: Icon.Attachment1,
  },
  [FieldTypes.NONPROFIT]: {
    label: 'Nonprofit Organization',
    defaultOpts: {},
    icon: Icon.PaginateFilterHeart,
  },
  [FieldTypes.SELECT]: {
    label: 'Select',
    defaultOpts: {options: [], displayAs: 'dropdown'},
    icon: Icon.ArrowButtonCircleDown,
  },
  [FieldTypes.MULTI_SELECT]: {
    label: 'Multi-Select',
    defaultOpts: {options: [], displayAs: 'list'},
    icon: Icon.ListBullets,
  },
  [FieldTypes.ADDRESS]: {
    label: 'Address',
    defaultOpts: {},
    icon: Icon.Pin,
  },
  [FieldTypes.PHONE]: {
    label: 'Phone Number',
    defaultOpts: {},
    icon: Icon.Phone,
  },
};

const makeNewForm = (attrs={}) => {
  return {
    id: utils.clientId(),
    title: null,
    description: null,
    formFields: [],
    ownerType: 'GrantProgram',
    ownerId: null,
    ...attrs,
  };
};

const makeNewField = (attrs={}) => {
  return {
    id: utils.clientId(),
    title: null,
    description: null,
    type: FieldTypes.TEXT_SHORT,
    opts: {},
    isRequired: false,
    ...attrs,
  };
};

const isNew = (objOrId) => {
  const isStr = typeof objOrId === 'string';
  const id = (isStr ? objOrId : objOrId.id);
  return id.startsWith(utils.CLIENT_ID_PREFIX);
};

// TODO: more logic to do here other than just not null
const isValidAnswer = (field, answer) => {
  if (!field.isRequired) return true;
  if (!answer) return false;
  const rawVal = answer.value[field.type];
  return rawVal != null;
};

const getFormSaveAttrs = (form, {forceValid=false}={}) => {
  const sanitizeString = str => (str || '').trim() || null;
  const obj = {
    title: sanitizeString(form.title),
    description: sanitizeString(form.description),
    formFields: form.formFields,
    ownerType: form.ownerType,
    ownerId: form.ownerId,
  };
  if (forceValid) {
    if (!obj.title) obj.title = 'New Form';
    obj.formFields = (obj.formFields || []).map((field, i) => {
      const fobj = {...field};
      if (!fobj.title) fobj.title = `Field #${i+1}`;
      if (!fobj.type) fobj.type = FieldTypes.TEXT_SHORT;
      return fobj;
    });
  }
  return obj;
};

export default {
  FieldTypes,
  typeObjMap,
  makeNewForm,
  makeNewField,
  isNew,
  isValidAnswer,
  getFormSaveAttrs,
};
